var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpPage",
    {
      attrs: {
        size: _vm.size,
        header: _vm.documentTitle,
        loaded: _vm.loaded,
        noShow: !_vm.loaded,
        modal: _vm.modal,
        "itp-cname": "BillingRules",
        modalBindings: _vm.b_7315092382398562_modalBindings
      },
      on: {
        close: function($event) {
          return _vm.evh_7315092382398562_close($event, {})
        }
      }
    },
    [
      _vm.loaded
        ? _c(
            "UcHeader",
            {
              attrs: {
                slot: "header",
                card: !_vm.modal,
                modal: _vm.modal,
                title: _vm.documentTitle
              },
              on: {
                close: function($event) {
                  return _vm.evh_2248226175642056_close($event, {})
                }
              },
              slot: "header"
            },
            [
              _c(
                "ItpBox",
                [
                  _c("ItpButton", {
                    staticClass: "ml-3",
                    attrs: {
                      variant: "light",
                      icon: "fa-sync-alt",
                      tooltip: _vm._f("gettext")("Reload"),
                      spinning: _vm.actions.reload.isRunning,
                      text: _vm._f("gettext")("Reload")
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.evh_6466705138206980_clickPreventStop(
                          $event,
                          {}
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("ItpButton", {
                    staticClass: "ml-3",
                    attrs: {
                      icon: "lets-icons:import",
                      text: _vm._f("pgettext")("Import", "Templates"),
                      variant: "light"
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.evh_8320016629450276_clickPreventStop(
                          $event,
                          {}
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("ItpButton", {
                    staticClass: "ml-3",
                    attrs: {
                      icon: "lets-icons:export",
                      text: _vm._f("pgettext")("Export", "BillingRules"),
                      variant: "light",
                      disabled: !_vm.items || !_vm.items.length,
                      "use-auth": "",
                      "force-download": "",
                      downloadFileName: "billing-rules.json",
                      href: _vm.$fn.urlFor("export_object_by_type", {
                        object_type: "billing-rule"
                      })
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "UcBody",
            { attrs: { card: !_vm.modal, modal: _vm.modal } },
            [
              (_vm.items && _vm.items.length) || _vm.createItem
                ? _c(
                    "b-list-group",
                    { style: _vm.b_1040167445267876_style },
                    [
                      _vm._l(_vm.items, function(item) {
                        return _vm.items && _vm.items.length
                          ? _c(
                              "b-list-group-item",
                              { key: item.id },
                              [
                                _c(
                                  "ItpBox",
                                  { attrs: { alignItems: "start" } },
                                  [
                                    _c("BillingRule", {
                                      staticClass: "flex-grow-1",
                                      attrs: {
                                        item: item,
                                        editing: _vm.editingItemID == item.id
                                      },
                                      on: {
                                        saved: function($event) {
                                          return _vm.evh_5731695935601903_saved(
                                            $event,
                                            { item: item }
                                          )
                                        },
                                        cancelEdit: function($event) {
                                          return _vm.evh_5731695935601903_cancelEdit(
                                            $event,
                                            { item: item }
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "DIV",
                                      {
                                        staticClass: "ml-3",
                                        style: _vm.b_1747314907724257_style
                                      },
                                      [
                                        _c(
                                          "b-dropdown",
                                          {
                                            attrs: {
                                              size: "sm",
                                              "toggle-class":
                                                "btn-default-borderless",
                                              "no-caret": "",
                                              variant: "none"
                                            }
                                          },
                                          [
                                            _c("ItpIcon", {
                                              staticClass: "mx-1",
                                              attrs: {
                                                slot: "button-content",
                                                fa: "ellipsis-v"
                                              },
                                              slot: "button-content"
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "b-dropdown-item-button",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    $event.stopPropagation()
                                                    return _vm.evh_4196617261796474_clickPreventStop(
                                                      $event,
                                                      { item: item }
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("ItpText", {
                                                  attrs: {
                                                    text: _vm._f("pgettext")(
                                                      "Edit",
                                                      "Command"
                                                    )
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-dropdown-item-button",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    $event.stopPropagation()
                                                    return _vm.evh_261555069697365_clickPreventStop(
                                                      $event,
                                                      { item: item }
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("ItpText", {
                                                  attrs: {
                                                    text: _vm._f("pgettext")(
                                                      "Delete",
                                                      "Command"
                                                    )
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      }),
                      _vm._v(" "),
                      _vm.createItem
                        ? _c(
                            "BListGroupItem",
                            [
                              _c(
                                "ItpBox",
                                { attrs: { alignItems: "start" } },
                                [
                                  _c("BillingRule", {
                                    staticClass: "flex-grow-1",
                                    attrs: { editing: "" },
                                    on: {
                                      saved: function($event) {
                                        return _vm.evh_2272469684735879_saved(
                                          $event,
                                          {}
                                        )
                                      },
                                      cancelEdit: function($event) {
                                        return _vm.evh_2272469684735879_cancelEdit(
                                          $event,
                                          {}
                                        )
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("DIV", {
                                    staticClass: "ml-3",
                                    style: _vm.b_8363486085232621_style
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.createItem
                        ? _c(
                            "BListGroupItem",
                            { staticClass: "border-0" },
                            [
                              _c(
                                "ItpBox",
                                { attrs: { justifyContent: "center" } },
                                [
                                  _c("ItpButton", {
                                    staticClass: "w-auto",
                                    attrs: {
                                      variant: "primary",
                                      text: _vm._f("pgettext")(
                                        "Create rule",
                                        "BillingRules"
                                      ),
                                      disabled: _vm.editingItemID != null
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        $event.stopPropagation()
                                        return _vm.evh_3373384577795494_clickPreventStop(
                                          $event,
                                          {}
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              (!_vm.items || !_vm.items.length) && !_vm.createItem
                ? _c(
                    "ItpBox",
                    {
                      style: _vm.b_4186377094414664_style,
                      attrs: {
                        direction: "column",
                        alignItems: "center",
                        justifyContent: "center"
                      }
                    },
                    [
                      _c("p", [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm._f("pgettext")(
                                "No rules have been defined yet.",
                                "BillingRules"
                              )
                            ) +
                            "\n      "
                        )
                      ]),
                      _vm._v(" "),
                      _c("ItpButton", {
                        attrs: {
                          variant: "primary",
                          text: _vm._f("pgettext")(
                            "Create rule",
                            "BillingRules"
                          )
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            $event.stopPropagation()
                            return _vm.evh_3601807637515735_clickPreventStop(
                              $event,
                              {}
                            )
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "UcFooter",
            {
              attrs: { slot: "footer", card: !_vm.modal, modal: _vm.modal },
              slot: "footer"
            },
            [
              _c(
                "ItpBox",
                { staticClass: "ml-auto" },
                [
                  _c("ItpButton", {
                    attrs: {
                      text: _vm._f("gettext")("Close"),
                      variant: "default"
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.evh_2140198529698299_clickPreventStop(
                          $event,
                          {}
                        )
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded ? _c("template", { slot: "footer" }) : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }